export function setItem(itemName: string, value: string) {
  sessionStorage.setItem(itemName, value)
}
export function getItem(itemName: string): string | null {
  return sessionStorage.getItem(itemName)
}
export function removeItem(itemName: string) {
  sessionStorage.removeItem(itemName)
}
